import * as React from "react";
export const CompleteReadyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 17.81 17.81" {...props}>
    <path d="M8.04 10.22c-.49-.52-.89-.93-1.28-1.36-.55-.61-1.16-1.02-1.91-.32-.72.66-.5 1.3.12 1.93.65.65 1.25 1.33 1.89 1.98 1.04 1.06 1.37 1.05 2.42-.05 1.41-1.47 2.79-2.96 4.22-4.41.63-.64.96-1.29.24-2.04-.8-.84-1.39-.25-1.97.36-1.22 1.28-2.45 2.56-3.73 3.91zm.87 7.59C3.99 17.81 0 13.82 0 8.91S3.99 0 8.91 0s8.91 3.99 8.91 8.91-4 8.9-8.91 8.9z" />
  </svg>
);
